
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guest-login",
      function () {
        return require("private-next-pages/guest-login/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guest-login"])
      });
    }
  